export default __webpack_public_path__ + "static/media/pinterest.2e45f071.svg";